import React from 'react';
import { Grid } from "../../ecosystem/";
import StickyProgressBar from '../../common/StickyProgressBar';

export const InHomeSplitLayout = ({
    className,
    children,
    progressPercent = 0
}) => {

    return (<>
        <StickyProgressBar className="inhome inhome-split-layout" widthInPercent={progressPercent} />
        <Grid className={`body-content body-content--no-top-offset body-content--no-footer inhome inhome-scheduling in-home-split-layout-container ${className ? className : ''}`}>
            <div className="row no-margins">
                {children}
            </div>
        </Grid>
    </>);
}

